import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import FrontendLayout from "../../components/frontend/FrontendLayout";
import NoResults from "../../components/admin/common/NoResults";
import { handleApiError } from "../../utils/apiHelpers";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

interface Blog {
  b_id: number;
  b_title: string;
  b_desc: string;
  b_pageurl: string;
  b_tag: string;
  b_postdt: string;
  b_img: string;
  b_status: number;
}

const Blogs: React.FC = () => {
  const [blogs, setBlogs] = useState<Blog[]>([]);
  const navigate = useNavigate();

  const fetchBlogs = async () => {
    try {
      const res = await axios.get(`${API_BASE}/api/blogs/frontend-list`);
      if (res.data.success) {
        setBlogs((res.data.blogs || []).filter((b: Blog) => b.b_status === 1));
      } else {
        toast.error(res.data.message || "Failed to fetch blogs");
      }
    } catch (err) {
      handleApiError(err, navigate);
    }
  };

  useEffect(() => {
    fetchBlogs();
  }, []);

  return (
    <FrontendLayout>
      <ToastContainer />
      <section
        className="flat-title style-2 mb-4 tf-spacing-1 inner-banner"
      >
        <div className="tf-container">
          <div className="row">
            <div className="col-lg-12">
              <div className="title-inner mb-0 pt-0 d-flex justify-content-between">
                <ul className="breadcrumb">
                  <li>
                    <Link to="/" className="home fw-6 text-color-3">
                      Home
                    </Link>
                  </li>
                  <li>Blog</li>
                </ul>
                <h5 className="mt-3">Blog</h5>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section-blog-grid">
        <div className="tf-container tf-spacing-1">
          <div className="row">
            <div className="col-12">
              <div className="grid-layout-3">
                {blogs.length > 0 ? (
                  blogs.map((blog) => (
                    <div
                      className="blog-article-item style-2 hover-img"
                      key={blog.b_id}
                    >
                      <div className="image-wrap">
                        <Link to={`/blogs/${blog.b_pageurl}`}>
                          <img
                            className="lazyload"
                            src={
                              blog.b_img
                                ? `${API_BASE}/uploads/blogs/${blog.b_img}`
                                : "/images/blog/blog-grid-1.jpg"
                            }
                            alt={blog.b_title}
                          />
                        </Link>
                        <div className="box-tag">
                          <Link to={`/blogs/${blog.b_pageurl}`}>
                            <i className="bi bi-arrow-up-right-circle-fill"></i>
                          </Link>
                        </div>
                      </div>
                      <div className="article-content">
                        <div className="time">
                          <div className="icons">
                            <i className="icon-clock"></i>
                          </div>
                          <p className="fw-5">
                            {new Date(blog.b_postdt).toLocaleDateString(
                              "en-GB",
                              {
                                day: "numeric",
                                month: "long",
                                year: "numeric",
                              }
                            )}
                          </p>
                        </div>
                        <h4 className="title line-clamp-3">
                          <Link to={`/blogs/${blog.b_pageurl}`}>
                            {blog.b_title}
                          </Link>
                        </h4>
                      </div>
                    </div>
                  ))
                ) : (
                  <NoResults description="No blogs found. Try checking back later." />
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </FrontendLayout>
  );
};

export default Blogs;
